import * as React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { debug } from '../../../utils';
import { LinkHelper } from '../../routes';
import { register } from '../../models/Auth';
import Button from '../../components/Button/Button';
const styles = require('./Register.less') as any;
const log = debug('lego:Register.tsx');
import { TextField, Toggle } from '../../components/fields';
import validate from './validators';
import Icon from 'react-fa';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { handleSubmissionError } from '../utils'

@connect(null, { register })
@reduxForm({form: 'register', validate})
export default class Register extends React.Component<any,any> {
		render() {
				const { handleSubmit, pristine, reset, submitting, error } = this.props

				return (
					<div id="RegisterPage">
						<div className={styles.container}>
							<h1 className={styles.heading}>Registering</h1>
							<form onSubmit={handleSubmit(handleSubmissionError(this.props.register))}>
								<div style={{position: 'relative', zIndex: 1000}}>
									Already have an account? Go to the <LinkHelper to='login'>Login page</LinkHelper>
								</div>

								<div style={{display: 'flex', 'flexDirection': 'column', alignItems: 'center'}}>
									<Field name='username' className="TextField" autoCapitalize='none'
												 component={TextField} label='Username' placeholder='Username' />
									<Field name='email' autoCapitalize='none'
												 component={TextField} label='Email Address' placeholder='you@youremail.com' />
									<Field name='confirm_email' className="TextField" autoCapitalize='none'
												 component={TextField} label='Re-enter email address' placeholder='you@youremail.com' />
									<Field name='password' autoCapitalize='none'
												 component={TextField} type="password" label='Password' placeholder='Password' />
									<Field name='confirm_password' autoCapitalize='none'
												 component={TextField} type='password'
												 label='Re-enter Password' placeholder='Password' />
								</div>
								<Field name='terms' component={Terms} label={<span>I agree to the</span>} labelPosition='right'
											 style={{
												 whiteSpace: 'nowrap',
												 paddingRight: '3px',
												 display: 'inline-block',
												 width:'initial'
											 }} />
								{error && <div><strong>{error}</strong></div>}
								<div style={{textAlign: 'right', marginTop: '0.5em'}}>
									<Button type='submit' disabled={pristine || submitting}>Register</Button>
									<Button type='button' kind='secondary' disabled={pristine || submitting}>Reset</Button>
								</div>
							</form>
						</div>
					</div>
				);
		}
}

const errorStyle = {
	position: 'relative',
  bottom: '15px',
  fontSize: '12px',
  lineHeight: '12px',
  color: 'rgb(244, 67, 54)',
	marginTop: '20px',
	zoom: 1.2,
}
const Terms = ({ input, label, meta, ...rest}) => (
	<div style={{marginTop: '20px'}}>
		<div style={{display: 'flex'}}>
			<Toggle input={input} label={label} meta={meta} {...rest} />
			<LinkHelper to='/Terms' target='_blank' style={{lineHeight: '1.5em'}}>Terms & Conditions <Icon name='external-link' /></LinkHelper>
		</div>
		{meta.touched && <div style={errorStyle}>{meta.error}</div>}
	</div>
)



// WEBPACK FOOTER //
// ./src/app/containers/Register/Register.tsx